import newsModule from '../scripts/news/news.module.js';
import appDependency from '../scripts/appDependency.js';
appDependency.addItem(newsModule);